var render = function render(){var _vm=this,_c=_vm._self._c;return _c('woot-reports',{key:"agent-reports",attrs:{"type":"agent","getter-key":"agents/getAgents","action-key":"agents/get","download-button-label":_vm.$t('REPORT.DOWNLOAD_AGENT_REPORTS')}})
}
var staticRenderFns = []

export { render, staticRenderFns }